module.exports = __webpack_public_path__ + "img/10-min.1ed24cdb.jpg";